// extracted by mini-css-extract-plugin
export var overlay = "cookienotice-module--overlay--M7TYK";
export var container = "cookienotice-module--container--WfYaO";
export var buttons_container = "cookienotice-module--buttons_container--GZ0Av";